import { render, staticRenderFns } from "./AppSection.vue?vue&type=template&id=0023aea2&scoped=true&"
import script from "./AppSection.vue?vue&type=script&lang=js&"
export * from "./AppSection.vue?vue&type=script&lang=js&"
import style0 from "./AppSection.vue?vue&type=style&index=0&id=0023aea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023aea2",
  null
  
)

export default component.exports